module.exports = __webpack_public_path__ + "img/df9da85.jpg";